// Which fields a vendor section shows, and whether they may be typed into.
//
// THREE STATES, from two independent questions:
//
//   order exists?        no  -> the award boxes;  yes -> just the member id
//   vendor id known?     yes -> editable;         no  -> read-only
//
// WHY READ-ONLY RATHER THAN HIDDEN. The section keeps its shape either way, so
// the row of boxes a cashier's eye is used to does not move when a lookup comes
// back empty. Greyed boxes also say something a missing row cannot: this is
// where a 折抵 goes, and it is unavailable right now.
//
// WHAT THE ID DECIDES, AND WHAT IT DOES NOT. Editability keys on the vendor id
// alone, never on the balances, because that is exactly the line the server
// draws in memberFromForm -- an award is built when there is someone to credit,
// and a balance we could not read does not change who that is. A member whose
// points the platform would not report can still redeem: the staff takes the
// customer's word for the figure, which is a judgement they are entitled to
// make and a loss the shop can absorb if it is wrong. Without an id nothing can
// settle at all, and the boxes would only invite a redemption that silently
// discounts the sale and deducts nothing -- the same trap the saved-order state
// exists to avoid.
//
// The reload icon stays live in both states, because re-asking the platform is
// how this section gets out of the read-only one. It sits on the member id
// field, which is already disabled and whose adornment already works.

import { vendorIdOf } from './memberBalance.js'

// `key` IS THE SIGNAL. It comes from a server-side counter at insert, so it is
// absent on an order being typed and present on one that exists -- which is
// exactly the line the awards are decided on.
function isCreated(doc) {
  return Boolean(doc && doc.key)
}

// A ui field entry may be a bare path string, which has nowhere to carry a
// flag, so it becomes an object.
//
// THE SCHEMA BEATS THE ENTRY, not the other way round: buildFormProps resolves
// a field as `merge(entry, schemaField)`. It works here only because pageConfig
// declares no `disabled` for these paths, so the schema contributes no such key
// and the entry's survives -- verified against buildUiFields. Adding any of
// them to pageConfig's `disabled` map, even as `false`, would silently take
// this over. Put a flag for one of these boxes here, never there.
function readOnly(field) {
  if (typeof field === 'string') return { path: field, disabled: true }

  return { ...field, disabled: true }
}

// The `ui` FormEditor should render for this section, given the document.
function vendorSectionUi(section, doc) {
  const fields = isCreated(doc) ? section.savedFields : section.fields

  if (vendorIdOf(doc, section.vendor)) return { ...section, fields }

  return { ...section, fields: fields.map(row => row.map(readOnly)) }
}

export { vendorSectionUi, isCreated }
